import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/Auth/AuthService';

interface PersonalDraft {
  fname: string;
  lname: string;
  email: string;
  phone_number: any;
  country: string;
  policy: boolean;
}

interface CompanyDraft {
  name: string;
  address: string;
  sector_id: any[];
  business_logo: any[];
  logoPreview: string | ArrayBuffer | null;
}

/** Navigation-only signup state. Never put credentials, OTPs or session tokens in a draft. */
@Injectable({ providedIn: 'root' })
export class OnboardingDraftService {
  personal: PersonalDraft | null = null;
  company: CompanyDraft | null = null;
  plan: any = null;
  countryISO: string | null = null;
  private registeredEmail: string | null = null;
  constructor(private auth: AuthService) {}

  savePersonal(value: any): void {
    if (this.registeredEmail) return;
    this.personal = {
      fname: value.fname ?? '',
      lname: value.lname ?? '',
      email: value.email ?? '',
      phone_number: value.phone_number ? {
        number: value.phone_number.number,
        internationalNumber: value.phone_number.internationalNumber,
        nationalNumber: value.phone_number.nationalNumber,
        e164Number: value.phone_number.e164Number,
        countryCode: value.phone_number.countryCode,
        dialCode: value.phone_number.dialCode,
      } : null,
      country: value.country ?? '',
      policy: value.policy === true,
    };
  }

  saveCompany(value: any, logoPreview: string | ArrayBuffer | null): void {
    this.company = {
      name: value.name ?? '',
      address: value.address ?? '',
      sector_id: value.sector_id ?? [],
      business_logo: value.business_logo ?? [],
      logoPreview,
    };
  }

  markRegistered(email: string, issuedToken: string | undefined): void {
    if (!this.auth.bindOnboardingSession(email, issuedToken)) return;
    this.registeredEmail = email.trim().toLowerCase();
  }

  get registeredIdentity(): PersonalDraft | null {
    return this.registeredEmail && this.personal?.email.trim().toLowerCase() === this.registeredEmail
      ? this.personal : null;
  }

  canContinue(email: string): boolean {
    return email.trim().toLowerCase() === this.registeredEmail && this.auth.hasOnboardingSession(email);
  }

  releaseRegistration(): void {
    this.registeredEmail = null;
    this.auth.clearOnboardingSession();
  }

  clear(): void {
    this.personal = null;
    this.company = null;
    this.plan = null;
    this.countryISO = null;
    this.registeredEmail = null;
    this.auth.clearOnboardingSession();
  }
}
